<br><br>

<form [formGroup]="orgForm" (ngSubmit)="submit()" class="auth-wrapper">
  <div class="auth-card">
    <h2 class="title">Tell Us More About Your Organisation</h2>
    <p class="subtitle">
      Share your organisation's contact information.
    </p>

    <!-- <div class="primary_contact">
      <h5>Primary Contact</h5>
    </div> -->
    <div class="row">
      <div class="col-lg-6">
        <div class="field full">
          <label>First Name <span class="required">*</span></label>
          <input type="text" formControlName="firstName" placeholder="John">
          <div class="error"
            *ngIf="(orgForm.get('firstName')?.touched || submitted) && orgForm.get('firstName')?.invalid">

            <small *ngIf="orgForm.get('firstName')?.errors?.['required']">
              First name is required*
            </small>

            <small *ngIf="orgForm.get('firstName')?.errors?.['minlength']">
              Minimum 2 characters required*
            </small>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="field full">
          <label>Last Name <span class="required">*</span></label>
          <input type="text" formControlName="lastName" placeholder="Doe">
          <div class="error"
            *ngIf="(orgForm.get('lastName')?.touched || submitted) && orgForm.get('lastName')?.invalid">

            <small *ngIf="orgForm.get('lastName')?.errors?.['required']">
              Last name is required*
            </small>

            <small *ngIf="orgForm.get('lastName')?.errors?.['minlength']">
              Minimum 2 characters required*
            </small>
          </div>
        </div>
      </div>


      <div class="col-lg-6 col-6">
        <div class="field">
          <label>Designation <span class="required">*</span></label>
          <ng-select [items]="designT" bindLabel="name" bindValue="name" [searchable]="true" placeholder="Designation"
            formControlName="designation">
          </ng-select>
          <div class="error"
            *ngIf="(orgForm.get('designation')?.touched || submitted) && orgForm.get('designation')?.invalid">

            <small *ngIf="orgForm.get('designation')?.errors?.['required']">
              Designation is required*
            </small>

          </div>
          <!-- <input type="text" formControlName="designation" placeholder="Event Manager">
          <div class="error"
            *ngIf="(orgForm.get('lastName')?.touched || submitted) && orgForm.get('lastName')?.invalid">

            <small *ngIf="orgForm.get('lastName')?.errors?.['required']">
              Designation is required*
            </small>
          </div> -->
        </div>
      </div>

      <div class="col-lg-6 col-6">
        <div class="field full">
          <label>Brand Name / Display Name <span class="required">*</span></label>
          <input type="text" formControlName="organization_name" placeholder="Your Organization Name">
          <div class="error"
            *ngIf="(orgForm.get('organization_name')?.touched || submitted) && orgForm.get('organization_name')?.invalid">

            <small *ngIf="orgForm.get('organization_name')?.errors?.['required']">
              Brand / Display Name is required*
            </small>

          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="field">
          <label>Email Address</label>
          <input type="email" formControlName="email" placeholder="user@example.com" readonly>

        </div>
      </div>

      <div class="col-lg-6">
        <div class="field">
          <label>Mobile <span class="required">*</span></label>
          <div class="mobile-group">

            <ng-select [items]="countriesCode" bindLabel="phonecode" bindValue="phonecode" style="width: 220px;"
              [searchable]="true" placeholder="" formControlName="countryCode" (keypress)="numberOnly($event)">
              <ng-template ng-option-tmp let-item="item">
                <span style="font-size: 16px; margin-right: 6px;">
                  {{ item.emoji }}
                </span>
                <span>+{{ item.phonecode }}</span>
              </ng-template>

              <!-- Selected value -->
              <ng-template ng-label-tmp let-item="item">
                <span style="font-size: 16px; margin-right: 6px;">
                  {{ item.emoji }}
                </span>
                <span>+{{ item.phonecode }}</span>
              </ng-template>
            </ng-select>
            <!-- <input type="phone" formControlName="phone" placeholder="8872077187"> -->
            <input type="tel" formControlName="phone" placeholder="8872077187" />

          </div>
          <div class="error" *ngIf="(orgForm.get('phone')?.touched || submitted) && orgForm.get('phone')?.invalid">

            <small *ngIf="orgForm.get('phone')?.errors?.['required']">
              Mobile is required*
            </small>

            <small *ngIf="orgForm.get('phone')?.errors?.['minlength']">
              Mobile must be at least 6 digits
            </small>

            <small *ngIf="orgForm.get('phone')?.errors?.['maxlength']">
              Mobile must be maximum 15 digits
            </small>

            <small *ngIf="orgForm.get('phone')?.errors?.['pattern']">
              Only numbers are allowed
            </small>


          </div>
          <div class="error"
            *ngIf="(orgForm.get('countryCode')?.touched || submitted) && orgForm.get('countryCode')?.invalid">
            <small *ngIf="orgForm.get('countryCode')?.errors?.['required']">
              Country code is required*
            </small>
          </div>
        </div>

      </div>

    </div>


    <!-- <div class="primary_contact">
      <h5>Organization</h5>
    </div> -->
    <div class="row">



      <div class="col-lg-12 col-12">
        <div class="field">
          <label>Business Type <span class="required">*</span></label>
          <ng-select [items]="businessTypes" bindLabel="name" bindValue="name" [searchable]="true"
            placeholder="Select Business Type" formControlName="businessType">
          </ng-select>
          <div class="error"
            *ngIf="(orgForm.get('businessType')?.touched || submitted) && orgForm.get('businessType')?.invalid">

            <small *ngIf="orgForm.get('businessType')?.errors?.['required']">
              Business Type is required*
            </small>

          </div>
        </div>
      </div>





    </div>

    <!-- <div class="primary_contact">
      <h5>Location</h5>
    </div> -->
    <!-- <div class="row">
        <div class="col-lg-6 col-12">
             <div class="field full">
              <label>Country *</label>
              <input type="text" formControlName="Organisation" placeholder="">
            </div>
        </div>


         <div class="col-lg-6 col-12">
                <div class="field">
                <label>State  *</label>
                <input type="text" formControlName="text" placeholder="">
              </div>
        </div>

         <div class="col-lg-12 col-12">
         
             <div class="field">
             
              <label>City</label>
              <input type="email" formControlName="email" placeholder="Enter City">
            </div>
        </div>

     
        
    </div> -->

    <div class="row">
      <div class="col-6">
        <label>Country <span class="required">*</span></label>
        <ng-select [items]="countries" bindLabel="name" (change)="onCountryChange($event)" bindValue="name"
          [searchable]="true" placeholder="Select Country" formControlName="country" [appendTo]="'body'">
        </ng-select>
        <!-- <select formControlName="country">
          <option value="">Select country</option>
          <option value="India">India</option>
        </select> -->
        <div class="error" *ngIf="(orgForm.get('country')?.touched || submitted) && orgForm.get('country')?.invalid">

          <small *ngIf="orgForm.get('country')?.errors?.['required']">
            Country is required*
          </small>
        </div>
      </div>
     

      <div class="col-6">
        <label>State <span class="required">*</span></label>
        <ng-select [items]="states" bindLabel="name" (change)="onStateChange($event)" bindValue="name"
          [searchable]="true" placeholder="Select State" formControlName="state">
          <option value="">Select state</option>
        </ng-select>
        <!-- <select formControlName="state">
          <option value="">Select state</option>
          <option value="Delhi">Delhi</option>
          <option value="Maharashtra">Maharashtra</option>
        </select> -->
        <div class="error" *ngIf="(orgForm.get('state')?.touched || submitted) && orgForm.get('state')?.invalid">

          <small *ngIf="orgForm.get('state')?.errors?.['required']">
            State is required*
          </small>
        </div>
      </div>

    </div>
    <div class="field full">
      <label>City <span class="required">*</span></label>
      <ng-select [items]="cities" bindLabel="name" bindValue="name" [searchable]="true" placeholder="Select City"
        formControlName="city">
      </ng-select>
      <div class="error" *ngIf="(orgForm.get('city')?.touched || submitted) && orgForm.get('city')?.invalid">

        <small *ngIf="orgForm.get('city')?.errors?.['required']">
          City is required*
        </small>
      </div>
      <!-- <select formControlName="city">
          <option value="">Select city</option>
          <option value="Delhi">Delhi</option>
          <option value="Mumbai">Mumbai</option>
        </select> -->
    </div>

    <div class="col-lg-12 col-12">

      <div class="field">
        <!-- <p class="social_links"> Social Links <span> (at least one required) </span> </p> -->
        <label>Website / Social Media <small class="one_req">(At least one required) <span class="error">*</span>
          </small></label>
        <input type="email" formControlName="website" placeholder="https://www.example.com">
        <div class="error" *ngIf="(orgForm.get('website')?.touched || submitted) && orgForm.get('website')?.invalid">

          <small *ngIf="orgForm.get('website')?.errors?.['required']">
            Website is required*
          </small>
          <small *ngIf="orgForm.get('website')?.errors?.['pattern']">
            Enter a valid URL (https://example.com)
          </small>
        </div>
      </div>
    </div>

    <div class="actions">
      <!-- <button type="button" class="btn secondary" routerLink="/login">Back</button> -->
      <button type="submit" class="primary-btn" *ngIf="!formfillNext"> Continue </button>
      <button type="button" class="primary-btn" (click)="next()" *ngIf="formfillNext"> Next </button>
    </div>


  </div>

  <div class="step-dots">
    <span class="dot"></span>
    <span class="dot active"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</form>

<br>

<div class="logout">
  <button (click)="logout()" class="primary-btn">Logout</button>
</div>